// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionG_comp__0Bkyj"};